import { useQuery } from '@tanstack/react-query';
import { packages } from '@shared/api/services';

// Пакеты (офферы) преподавателя для предложения ученику
export const useTeacherOffers = (slug, enabled) => {
  return useQuery({
    queryKey: ['teacher-offers', slug],
    queryFn: () => packages.getTeacherAvaiablePacks(slug),
    select: (data) => data?.data,
    enabled: !!slug && enabled,
  });
};
